<template>
  <div class="row-fluid">
    <div class="span8 report-title">
      <div class="printlink" @click="openFilterModal()">
        <i :class="[iconClass]"></i>
        {{ label }}
      </div>
    </div>
    <div>
      <div class="span1 center" style="margin-left: 15px">
        <i v-if="type == 'CSV'" class="report-csv-icon fa-light fa-file-excel" @click="openFilterModal()"></i>
      </div>
      <div class="span1 center" style="margin-left: 15px">
        <div v-if="data">
          <!-- <printlink :href="'/it/reports/generate_report'" :use_print_service="true" :params="{ data: csv_data,
                                                                                                type: 'CSV',
                                                                                                worker: 'csv_data_extraction' }"> -->
          <i v-if="type == 'PDF'" class="report-pdf-icon fa-light fa-file-pdf" @click="openFilterModal()"></i>
          <!-- </printlink> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import startEndDateFilter from '../print/filters/startEndDateFilter';
import unitsSelectorFilter from '../print/filters/unitsSelectorFilter';
import monthYearFilterVue from '../print/filters/monthYearFilter.vue';
import dismissedFilter from '../print/filters/dismissedFilter.vue';

export default {
  name: 'reportPrintRow',
  components: {},
  props: {
    data: {},
    type: {},
    worker: {},
    label: {},
    filters: {},
    iconClass: { type: String, default: 'fa-light fa-user red' },
  },
  data() {
    return {
      isLoading: false,
      reports: [],
      filtersComponent: [],
    };
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  mounted() {
    if (this.filters) {
      this.filtersComponent = this.filters.map((filter) => {
        switch (filter) {
          case 'startEndDateFilter':
            return startEndDateFilter;
          case 'monthYearFilter':
            return monthYearFilterVue;
          case 'unitsSelectorFilter':
            return unitsSelectorFilter;
          case 'dismissedFilter':
            return dismissedFilter;
          default:
            break;
        }
      });
    }
  },
  methods: {
    openFilterModal() {
      eventBus.$emit('openGenericFiltersModal', {
        filters: this.filtersComponent,
        params: { data: this.data, worker: this.worker, type: this.type },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
i,
.printlink {
  cursor: pointer;
}
</style>
